var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrain = function SvgBrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "188 114 710 845"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".brain_svg__st0,.brain_svg__st1{fill:none;stroke:#bcd7df;stroke-linecap:round;stroke-linejoin:round}circle.brain_svg__st0,ellipse.brain_svg__st0{fill:url(#brain_svg__grad1);stroke:none}")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "brain_svg__grad2",
    cx: "50%",
    cy: "50%",
    r: "50%",
    fx: "50%",
    fy: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fce0bd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#bcd7df"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brain_svg__Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brain_svg__Layer_6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 244.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 611.8,
    cy: 277.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 611.8,
    cy: 297.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 611.8,
    cy: 318.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 267,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 284.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 312,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 332,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 574.9,
    cy: 305.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 226.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 214.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 202,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 188.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 174,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.9,
    cy: 160,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 573.8,
    cy: 135.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585.8,
    cy: 127.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.9,
    cy: 218,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614.5,
    cy: 208.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624.2,
    cy: 198.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 633.9,
    cy: 189,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 647.3,
    cy: 209,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 193.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 678.6,
    cy: 195.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.1,
    cy: 163.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706.3,
    cy: 172.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730.8,
    cy: 196.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.8,
    cy: 154,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675.6,
    cy: 144.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 665.3,
    cy: 135.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 655.1,
    cy: 126.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 644.8,
    cy: 117.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.2,
    cy: 142,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.9,
    cy: 125.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.9,
    cy: 119.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 453.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 405.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 375.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 571.1,
    cy: 474.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 581.1,
    cy: 464.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.1,
    cy: 454.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.6,
    cy: 445.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 611.1,
    cy: 434.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642.3,
    cy: 434.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652.3,
    cy: 424.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662.3,
    cy: 414.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 678.8,
    cy: 324.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689.2,
    cy: 313.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.6,
    cy: 302.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710,
    cy: 291.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 720.4,
    cy: 280.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730.8,
    cy: 269.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 678.8,
    cy: 249.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 757.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 768.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 780.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 791.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 596.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 590.9,
    cy: 565.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602.9,
    cy: 553.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 613.6,
    cy: 543,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 638.8,
    cy: 539.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 639.9,
    cy: 575,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650.9,
    cy: 563.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 661.9,
    cy: 551.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 684.6,
    cy: 476.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676.2,
    cy: 468.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 667.9,
    cy: 459.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 659.6,
    cy: 451.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 681.9,
    cy: 497.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.9,
    cy: 512.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 675.4,
    cy: 521.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739.5,
    cy: 534.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 782.6,
    cy: 242.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 792.8,
    cy: 251.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 772.3,
    cy: 233.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.1,
    cy: 223.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.8,
    cy: 214.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.8,
    cy: 281.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.8,
    cy: 298.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.8,
    cy: 315.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.8,
    cy: 332.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 825.8,
    cy: 341.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.5,
    cy: 424.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.5,
    cy: 452.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.5,
    cy: 467.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.5,
    cy: 484.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740.5,
    cy: 499.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843.3,
    cy: 360.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 836,
    cy: 393.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 857.7,
    cy: 410.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880.5,
    cy: 433.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.3,
    cy: 463,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.7,
    cy: 405.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.3,
    cy: 478.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.3,
    cy: 489,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.3,
    cy: 498.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.3,
    cy: 525.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.3,
    cy: 540.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.3,
    cy: 555,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 881.8,
    cy: 566.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 822.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 833.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 845.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 865,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 876.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 887.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 899,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.9,
    cy: 927.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.3,
    cy: 935,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 587.7,
    cy: 942.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600.1,
    cy: 950.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 511.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 528.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 544.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.2,
    cy: 560.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.3,
    cy: 495.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.3,
    cy: 513.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.3,
    cy: 530.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.3,
    cy: 603.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 809.3,
    cy: 519.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.3,
    cy: 627.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 831.5,
    cy: 807.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 824.8,
    cy: 778,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 770.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 846.5,
    cy: 754.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 857.4,
    cy: 743.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 868.2,
    cy: 731.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 824,
    cy: 814.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 816.5,
    cy: 822.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806.5,
    cy: 832.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.5,
    cy: 842.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786.5,
    cy: 852.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 787.6,
    cy: 576.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 799.9,
    cy: 588.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 812.2,
    cy: 600.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 824.5,
    cy: 611.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.4,
    cy: 647,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.4,
    cy: 690.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.5,
    cy: 690.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880.3,
    cy: 690.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 769.3,
    cy: 690.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 755,
    cy: 658.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 769.3,
    cy: 690.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 759.2,
    cy: 700.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 759.2,
    cy: 700.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 769.3,
    cy: 710.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 769.3,
    cy: 735,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.5,
    cy: 749.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 769.3,
    cy: 868.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.8,
    cy: 887.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.5,
    cy: 942.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 633.5,
    cy: 958.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612.5,
    cy: 958.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 647,
    cy: 712.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 647,
    cy: 758.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 584.6,
    cy: 722.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.4,
    cy: 658.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 678,
    cy: 674.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706.7,
    cy: 703.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 718.8,
    cy: 715.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 678,
    cy: 822.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 655.5,
    cy: 845.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 659.9,
    cy: 931.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 669.9,
    cy: 924.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.7,
    cy: 425.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.3,
    cy: 762.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 865,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 876.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 887.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 899,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 822.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 833.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 845.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.7,
    cy: 921.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.8,
    cy: 931.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 942.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.1,
    cy: 958.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.1,
    cy: 953.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 910,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 784.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 798.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.5,
    cy: 798.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.8,
    cy: 798.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.9,
    cy: 737.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.3,
    cy: 737.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.6,
    cy: 737.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.9,
    cy: 762,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.1,
    cy: 833.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.8,
    cy: 833.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.8,
    cy: 705.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.6,
    cy: 537.1,
    r: 2.6,
    className: "brain_svg__st0",
    transform: "rotate(-2.335 438.614 537.155)scale(1.00003)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.5,
    cy: 554.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.5,
    cy: 564.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.5,
    cy: 574.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.5,
    cy: 486,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.5,
    cy: 497.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.5,
    cy: 509.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.5,
    cy: 520.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.5,
    cy: 537.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.8,
    cy: 566.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.6,
    cy: 569.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.1,
    cy: 559.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.6,
    cy: 550.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.1,
    cy: 540.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.6,
    cy: 531.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.1,
    cy: 508.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.1,
    cy: 498.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.1,
    cy: 712.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 484.1,
    cy: 723.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.2,
    cy: 734.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.3,
    cy: 745.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 517.3,
    cy: 756.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.3,
    cy: 940.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.2,
    cy: 946.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.2,
    cy: 952.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 756.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 527.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 477.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 495.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 325.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 302.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 287.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 268,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.5,
    cy: 246.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.7,
    cy: 214.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.7,
    cy: 202,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.7,
    cy: 188.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.8,
    cy: 174,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.5,
    cy: 411.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.5,
    cy: 453.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.5,
    cy: 474,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.5,
    cy: 494.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.5,
    cy: 432.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.5,
    cy: 362.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.5,
    cy: 392.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.4,
    cy: 232.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.2,
    cy: 220.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.1,
    cy: 209,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.9,
    cy: 197.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.3,
    cy: 285.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.1,
    cy: 273.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 261.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.4,
    cy: 358.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.8,
    cy: 348.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.3,
    cy: 337.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.7,
    cy: 327.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.6,
    cy: 420.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.3,
    cy: 410.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.9,
    cy: 401.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.5,
    cy: 391.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.6,
    cy: 430.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.4,
    cy: 458.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.4,
    cy: 474.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.4,
    cy: 519.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 519.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.4,
    cy: 537.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.9,
    cy: 547.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.4,
    cy: 556.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.3,
    cy: 409.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.9,
    cy: 263,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.3,
    cy: 272.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373,
    cy: 282.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.4,
    cy: 291.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.9,
    cy: 301,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.3,
    cy: 281.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.4,
    cy: 246.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.4,
    cy: 197.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.8,
    cy: 159,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.8,
    cy: 159,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.8,
    cy: 152.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.3,
    cy: 142.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.7,
    cy: 131.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.1,
    cy: 121.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456.1,
    cy: 121.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.1,
    cy: 121.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.2,
    cy: 152.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 518.7,
    cy: 142.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 508.3,
    cy: 131.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.9,
    cy: 121.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.7,
    cy: 193.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.1,
    cy: 193.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.5,
    cy: 193.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.7,
    cy: 193.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 484.7,
    cy: 193.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.5,
    cy: 921.3,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.8,
    cy: 931.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.3,
    cy: 931.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.8,
    cy: 893.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.8,
    cy: 879.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.8,
    cy: 737.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.3,
    cy: 867.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.8,
    cy: 854.5,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.8,
    cy: 841.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.6,
    cy: 829.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.3,
    cy: 818.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.4,
    cy: 786.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.4,
    cy: 776.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.5,
    cy: 457.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 600.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 617.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 633.9,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 652.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.9,
    cy: 668.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 564.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.3,
    cy: 696.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 696.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.6,
    cy: 740.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.2,
    cy: 749.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.9,
    cy: 758.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 745.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.9,
    cy: 209.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.3,
    cy: 320.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.3,
    cy: 301.4,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.3,
    cy: 280.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.7,
    cy: 416.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.2,
    cy: 425.6,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.8,
    cy: 435.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.3,
    cy: 444.7,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.7,
    cy: 454.1,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.4,
    cy: 658.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.4,
    cy: 648.8,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.1,
    cy: 249.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.1,
    cy: 223.2,
    r: 2.6,
    className: "brain_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.1,
    cy: 237,
    r: 2.6,
    className: "brain_svg__st0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "brain_svg__Layer_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.9 639.3v9M712.9 639.3v9M712.9 546.8v9M705.4 546.8v9M705.4 639.3v9M697.9 546.8v9M727.9 546.8v9M735.4 639.3v9M720.4 546.8v9M727.9 639.3v9M720.4 639.3v9M735.4 546.8v9M673.4 631.3h9M673.4 593.8h9M673.4 601.3h9M673.4 616.3h9M673.4 586.3h9M673.4 608.8h9M673.4 571.3h9M690.4 639.3v9M690.4 546.8v9M673.4 563.8h9M673.4 578.8h9M563.3 696.6c1.3 0 2.4-1.1 2.4-2.4v-19.1c0-1.3-1.1-2.4-2.4-2.4h-19.1c-1.3 0-2.4 1.1-2.4 2.4v19.1c0 1.3 1.1 2.4 2.4 2.4zM682.4 623.8h-9M765.9 563.8h9M765.9 608.8h9M765.9 623.8h9M765.9 616.3h9M774.9 631.3h-9M765.9 593.8h9M765.9 586.3h9M765.9 578.8h9M765.9 601.3h9M765.9 571.3h9M757.9 546.8v9M757.9 639.3v9M750.4 546.8v9M742.9 639.3v9M750.4 639.3v9M742.9 546.8v9M545.8 677.5h10.3M545.8 680h13.3M545.8 682.5h8M332.5 679.2h17.8M332.5 681.7h23M332.5 684.2h13.7M367.3 706.4h7.3M693.8 568.6h17.8M693.8 571.1h23M693.8 573.6h13.7M373.9 672.7h4c1.5 0 2.6 1.2 2.6 2.6v34.4c0 1.5-1.2 2.6-2.6 2.6h-50.1c-1.5 0-2.6-1.2-2.6-2.6v-34.4c0-1.5 1.2-2.6 2.6-2.6z",
    className: "brain_svg__st1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "brain_svg__Layer_8",
    d: "m561.3 546.4 51.9-51.9h38.2L676 470m-7.7-9.3-22.5 22.5h-37.5l-46.9 46.9m75.8 11.1-12.4 12.4v102.9m21.7 56.8v45.3m-86.1 64.9h51.2l49.7-49.7v-73.6l-21.9-21.9V576.5m22.3-163 1.5-187.1-16.4-16.4m-35.6 90-31.9-31.9h-19.7m51.6 10.3-32.9-32.9h-18.7m128.9 68.9v-89.2l-29.9-29.9M699 303.7v-86.6l-20.7-20.8m-118.6 30.9h21l52.3-52.3 32.6.2 18.7-18.7M343.7 541.8v75.6l19.7 19.7v36.7m314.9-423.1v74.8M472.7 711.6V542.9l-21.2-21.2H401m93.8 213V534.5l-37-37H401m82.6 227.2V538.6l-28.2-28.2H401m115.9 247.2V508.4L482 473.5h-36.5L431 458.9h-29.2m209-140.2-33.1-33.1h-18M353.3 532.3v72.1l20 20v49.3m32.5-428.2v38.3M401 538.1v16.7l11.3 12.4m-26.6-67.4v76.7l19.1 19.1v53.8m-29.1-139.6v76.7l19.1 19.1v56.3m111 83.7V530.1L462.7 487H401m126.7-311.3-48.5 48.5v23.7l-18.5 18.5v188.1m31.4-229.3 35.3-35.3m53.2 274.9v-91.2l-22.4-22.4-35.4 35.4m77.1 57.4v-91.6l-39.2-39.2M405.8 195.3 382.1 219v74.8m208.2 160.6v-91.8l-29.2-29.2m-135.5-137-34.1 34.1s.2 71.1 0 70.9m92.2-106.1-13.5 13.5v28.5L451 256.5v189.7M438.3 210 422 226.3v189.5m38.2-221.2v35.2l-18.5 18.5V435m9.3-240.8V217l-18.9 18.9v190m57.2 338.6v6.9l14.5 14.5h24.6m-84.9-209.4v106.9l-25.3 25.3v69.8l45.7 45.7h62.8m-92.7-259 .1 112.6-26.8 26.8V784l51.3 51.3h68.9M424 555.2v120.4l-25.7 25.7V790l56.4 56.4h74m.7-420.5 7 7c.3.3.8.3 1.1 0l7-7c.3-.3.3-.8 0-1.1l-7-7c-.3-.3-.8-.3-1.1 0l-7 7c-.3.3-.3.8 0 1.1m-1.2 101.8v229.9m-154.9-44.3v132L394 866h133m.8-562.9L480 351v68l20.2 20.2V469l27.1 27.1m4.3-83.6c.3-.3.3-.8 0-1.1l-7-7c-.3-.3-.8-.3-1.1 0l-7 7c-.3.3-.3.8 0 1.1l7 7c.3.3.8.3 1.1 0zm-66.4 326.1 11.8 11.8v19.3l30.3 30.3h20.8m-194.6-86.7V884l27 27h168M363.4 713.3V854l23.5 23.5h142.3M315.2 569v77.7l18.3 18.3v8.7m8.6 39.6v159.5l27.2 27.2H529M353.8 713.3v149l26.5 26.5H529m-2.4 33.9H423.3L404 942m-79.4-382.7v76.4l19.1 19.8v18.3m395.2-138.7-38.7-38.7-25.8 25.8M559.7 834.8h59.5l53.6-53.6V700l-22.4-22.4V566.5m-90.7 205H585l24.7-24.7v-32l-19.4-19.4V566.8m-30.6 214.5h37.5l26.3-26.3v-44.5l-21-21V554.2m-43 238.3H607l27.3-27.3V705l-21.1-21.1V543.3m69.8-65.1-27 27h-38.2l-56.7 56.7m-1.4 196.7h16.4l22.6-22.6v-16l-19-19V578.8l-17.3 17.3m-1 250.3h66l57.9-57.9v-89.6L661.4 675V554.2m16.1 269.3-22.6 22.6m11.6-332.6 14.9-14.9M436.7 737.5l12.4 12.4v21.7l28.2 28.2m86.6 126.3 25.2-25.2h-29.3M870 691.6v-86.9L761.8 496.5M668.7 925h29.9l55.3-55.3V749.8m83-58.2V648m29.2 83.8-5.6-5.6V611.8L763 514.3m-521.7 50.9h-16L187.5 603m39.8 155.4 11.5-11.5m-20.4 3 20.9-20.9V581.4h-14.6l-37.3 37.3m21.9 123.4 17.3-17.3V596.3l-39.3 39.3m54.3-115.3 19.2-19.2v-90.4m-50.3 147 18.7-18.7v-32.8l17.9-17.9V366.8l-6.9-6.9m-48.6 115.8 19.4-19.4v-33m-19.3 96.6 13.3-13.3v-28.4l17.9-17.9V413m-31.1 46.8 8.3-8.3v-20.1m-8.4 107.8 20.8-20.8v-30.6l17.1-17.1v-65.3m-28.7 143.4 20.9-20.9v-31.2l17.5-17.5v-87.5m.9-31.8-.2-.2m278.6 39.1c.3-.3.3-.8 0-1.1l-7-7c-.3-.3-.8-.3-1.1 0l-7 7c-.3.3-.3.8 0 1.1l7 7c.3.3.8.3 1.1 0zm17.7 1.7-7.5 7.5m12.2 13.3 8.2-8.2-26.5-26.5m-6.7 6.6 6.8-6.8m47.8 89.3V386l-10.8-10.8m50.5 58.5v-91.2l-35-35m-48 20.4-36.5 36.5v48.2l19.4 19.4v28.8l17.5 17.5M641.8 435V245l-18-18v-27.3M604.3 219v28.7l17.7 17.7v188.2l9.3-9.3V257.8L615 241.4V210m36.8 214.5V236.2l-18.3-18.3v-27.6M437.9 707.2l19.9-19.9V557.8L440 540m-16.2 295.8L398 810v24.3m162.7-427v47.1m-68.2-203.5 35.7-35.7m-.2 32.5h-19.8l-32.8 32.8m-23.9 458.2 11.9 11.9v21.6l27.7 27.7m1-561 35.4-35.4m.5 65.3h-19.1l-33.5 33.5m52.6-14.4h-19.2l-33.4 33.4m184.1 130.8L640 471.6h-37.5l-41.2 41.2m230.8-259.5V285l-71 71v49.9l18.6 18.6M353.8 262.8v-64.9m23-39.6v14.2m-31.7 192.7v27M563.8 160l9.7-9.7v-12.8m51.8-17.4h-14.8l-6.2 6.2M559.7 175h9l16.7-16.7V130M458 122.5h16.7M786.9 575v166.5l37.4 37.4m-7.3 45.6-11.1-11.1v19.3m6.6-233.8v138.5l26.2 26.2m-39-175.3v151.5l31.9 31.9m27.6-26.7-9.7-9.7V617.7l-89-89m8.3 163.7v-18.2l-14.4-14.4m14.1 76.2v133.6m-110.8 62.8h49.7l42.5-42.5m81.2-81.8L786 763v90.2m36.9-38.3-26.6-26.6v54.9M823.9 614v119.7l22.1 22.1M695.9 943.3H649l-15.8 15.8m183.9-659.2L755 362v25l20.9 20.9v31.5l116.7 116.7m-76.5-238.2-48.6 48.6V386l20.9 20.9V437L891 539.6m-557 12.2v74.4l19.7 19.7v27.8m539.1-45.4-13-13v76.4m-71-171 84 84m-75.6-322.1L742.8 357v32l21.5 21.5V450l117.5 117.5m-451 391.7-.2.2M276.2 842.9V546.8l25.5-25.5V358.5l-30.6-30.6M265 829.7V540.2l22.7-22.7V366l-27.5-27.5m-6.3 480.6V532.4l21.4-21.4V374l-24.6-24.6m50.1 518.7V558.8l27-27V347.3L273.5 293v-18.5m15.7 581V553.2l26-26v-175l-53.5-53.5v-10.9m-18.8 499.3V767l-10.4 10.4M204 697.6v-45l-16.6 16.6m27.2 28.1v-71.7l-27.3 27.3m427.3 302.7 44.5-44.5h36.4l45.7-45.7V738.8l27.3-27.3m-453.3 27.1v142m244.5-14.4h101.6l34.2-34.2V693.5l-17.3-17.3M575.5 934.5l43-43-3.8-3.8h-54.9m29.8 54.4 54.5-54.5h36.2L718 850V716.5M601.8 948.7l49.6-49.6h36.4l41.4-41.4V731.5l27.5-27.5m-197 172.2h109.6l36.8-36.8V705.7m-152.8-8.1v38.9l7.1 7.1h8.1L584 728v-2.7m-254 170 27.3 27.3H402m-7.3 9.4h-27.9m110.3 22.2h-41.3l-5 5m63.6-15.9h-61.8l-10.8 10.8m86.9-21.7h-80.1l-16 16m359.2-714.3v44.2L699 351.1v77.1l40 40M391.5 163.8v-5.5m390.4 85v37.1l-72.4 72.4v69.6l31.8 31.8m20.2-229.3V276l-73.9 73.9v83.7l52.8 52.8m-336.3-333 17 17h90.8l15.8-15.8m-136.2 9.2v24.9l-18.8 18.8V284m378.6-68.1v57.6l-74.7 74.7v89.4l63.9 63.9m-363.7-329V185l-14 14v74.5m-17.4 201.4 50.9-50.9v-74.8l-74.6-74.6v-64.2m92.3-67.6 15.5 15.5h74l13.9-13.9M345 495.6l62.8-62.8v-89.2l-74.3-74.3v-71.1M719.6 281v-82.7l-13.8-13.8v-10.6m-281.3-41.6 15 15h53.8l14.2-14.2m52.2 82.2h18l49.8-49.8h28l19.4-19.4m-115.2 56.7h15.7l46.9-46.9h23.3l19.2-19.2m-229.4-14.6 13.7 13.7h35.4l12.2-12.2m103 19.4 10.9-10.9h20.1l12.1-12.1m-83.1 69.3h13.9l42.5-42.5h19.1l19.5-19.5m75.5 142.4v-72.4M345.4 454.2l38.7-38.7v-63.4l-74.4-74.4v-55.1m420.5-25.3v-.3m-20.8 95.4v-83.1l-13.9-13.9v-30.2M344 413.8l18.1-18.1v-33.4l-76.6-76.6v-23m531.9 71L782.1 369v16.6l18.6 18.6V435l90.3 90.3m0-63.1-56.9-56.9m-9.1-63-30.8 30.8v10.1l19.7 19.7v30.6l66.1 66.1h11m0-37.4 1.8 1.8m-35.3-52 22.5 22.5m-44.9-41v-6.1l7.6-7.6v-18.5m-6.3 66.3 51.9 51.9h4.5m-549.2-44.7 30.1-30.1v-46.6l-75.9-75.9v-46.6m525.5 194 60.4 60.4h9.1",
    className: "brain_svg__st1",
    style: {
      opacity: 0.4
    }
  }));
};
export default SvgBrain;